import { getAuthAxios } from "@artprov/design-system";
import { errorService } from "../../../common/utils/functions/error.service.js";
import { formatCurrency } from "../../../common/utils/functions/formatCurrency.js";

export const getEstadisticas = async (signal = null) => {
    try {
        const response = await getAuthAxios("default").get(
            '/judicial/matching-judicial/estadisticas',
            signal ? { signal } : undefined
        );

        return response.data;
    } catch (error) {
        errorService.handleError(error, {
            userMessage: "No pudimos obtener las estadísticas.",
            origen: "getEstadisticasJudicial"
        });
        throw error;
    }
};

export const parseEstadisticas = (data) => {
    if (!data) return null;

    return {
        sinAsignar: data.sinAsignar || 0,
        montoSinAsignar: formatCurrency(data.montoSinAsignar || 0),
        asignadosHoy: data.asignadosHoy || 0,
        match100: data.match100 || 0,
        matchMenor100: data.matchMenor100 || 0,
        asignados: data.asignados || 0
    };
};
